export const UPDATE_NUM_DAYS = process.env.NODE_ENV === 'development' ? -1 : 30;
